/**
 * 主题存储 Key
 * @type {string}
 */
export const THEME_KEY = '__app_theme__';

/**
 * 远程主题配置缓存 Key
 * @type {string}
 */
export const REMOTE_THEME_KEY = '__remote_theme__';

/**
 * 默认配色方案名称
 * @type {string}
 */
export const DEFAULT_SCHEME = 'default';

// ── PC 端预设（zht-admin / brand-admin / marketing） ──

export const WEB_PRESETS = {
  default: {
    // 品牌色
    primary: '#5B5CF0',
    primaryHover: '#4338CA',
    primaryLight: '#EEF2FF',
    // 背景色
    bgPage: '#F0F2F5',
    bgCard: '#FFFFFF',
    bgHover: 'rgba(0, 0, 0, 0.04)',
    scrollbarThumb: '#C9D8EA',
    scrollbarThumbHover: '#AFC4DD',
    scrollbarTrack: 'transparent',
    tableHeaderBg: '#F7FAFE',
    // 文字色
    textPrimary: '#0F172A',
    textSecondary: '#64748B',
    textTertiary: '#94A3B8',
    textPlaceholder: '#9CA3AF',
    textBody: '#0F172A',
    textHeading: '#0F172A',
    textInverse: '#FFFFFF',
    // 边框色
    borderColor: '#999999',
    borderDefault: '#E2E8F0',
    borderLight: '#F1F5F9',
    bgPlaceholder: '#F1F5F9',
    // 功能色
    success: '#22c55e',
    warning: '#f59e0b',
    error: '#ef4444',
    info: '#3b82f6',
    // Header
    headerBg: '#FFFFFF',
    headerGradient: '#fff',
    // Modal
    modalContentBg: '#FFFFFF',
    modalHeaderBg: '#FFFFFF',
    modalTitleColor: '#0F172A',
    modalFooterBg: '#FFFFFF',
    // Menu
    menuSelectedText: '#FFFFFF',
    // Button
    buttonPrimaryText: '#FFFFFF',
    // 全局状态
    textDisabled: '#94A3B8',
    // Sidebar
    siderBg: '#0F172A',
    siderBgHover: '#1E293B',
    siderBgActive: '#4338CA',
    siderItemBg: 'transparent',
    siderText: '#E2E8F0',
    siderTextHover: '#FFFFFF',
    siderTextActive: '#FFFFFF',
    siderIcon: '#94A3B8',
    siderIconHover: '#CBD5E1',
    siderIconActive: '#FFFFFF',
    siderGradient: 'linear-gradient(180deg, #0F172A 0%, #0F172A 100%)',
  },
  'soft-blue': {
    // 品牌色
    primary: '#1677FF',
    primaryHover: '#0958D9',
    primaryLight: '#EAF4FF',
    // 背景色
    bgPage: '#EEF6FF',
    bgCard: '#FFFFFF',
    bgHover: 'rgba(22, 119, 255, 0.06)',
    scrollbarThumb: '#C9D8EA',
    scrollbarThumbHover: '#AFC4DD',
    scrollbarTrack: 'transparent',
    tableHeaderBg: '#F7FAFE',
    // 文字色
    textPrimary: '#243246',
    textSecondary: '#66758A',
    textTertiary: '#94A3B8',
    textPlaceholder: '#9AA8BA',
    textBody: '#334155',
    textHeading: '#1F2A3D',
    textInverse: '#FFFFFF',
    // 边框色
    borderColor: '#C9D7E8',
    borderDefault: '#D6E3F2',
    borderLight: '#E6EEF8',
    bgPlaceholder: '#F3F8FF',
    // 功能色
    success: '#16B981',
    warning: '#F59E0B',
    error: '#EF4444',
    info: '#1677FF',
    // Header
    headerBg: '#FFFFFF',
    headerGradient: '#FFFFFF',
    // Modal
    modalContentBg: '#FFFFFF',
    modalHeaderBg: '#FFFFFF',
    modalTitleColor: '#1F2A3D',
    modalFooterBg: '#FFFFFF',
    // Menu
    menuSelectedText: '#0958D9',
    // Button
    buttonPrimaryText: '#FFFFFF',
    // 全局状态
    textDisabled: '#A8B4C4',
    // Sidebar
    siderBg: '#FFFFFF',
    siderBgHover: '#EAF4FF',
    siderBgActive: '#DCEBFF',
    siderItemBg: 'transparent',
    siderText: '#465569',
    siderTextHover: '#0958D9',
    siderTextActive: '#0958D9',
    siderIcon: '#5D6B7F',
    siderIconHover: '#0958D9',
    siderIconActive: '#0958D9',
    siderGradient: '#FFFFFF',
  },
  champagne: {
    // 品牌色
    primary: '#CBC797',
    primaryHover: '#A7A066',
    primaryLight: '#F1EED8',
    // 背景色
    bgPage: '#EEF2F3',
    bgCard: '#FAFAF3',
    bgHover: '#F0EFE3',
    scrollbarThumb: '#C9D0D4',
    scrollbarThumbHover: '#AEB8BE',
    scrollbarTrack: 'transparent',
    tableHeaderBg: '#F2F4EF',
    tableFixedHoverBg: '#F0EFE3',
    cardShadow: '0 8px 24px rgba(37, 48, 68, 0.055)',
    cardShadowStrong: '0 10px 28px rgba(37, 48, 68, 0.075)',
    // 文字色
    textPrimary: '#253044',
    textSecondary: '#667085',
    textTertiary: '#98A2B3',
    textPlaceholder: '#A6B0BE',
    textBody: '#344054',
    textHeading: '#1D2939',
    textInverse: '#FFFFFF',
    // 边框色
    borderColor: '#D0D6D0',
    borderDefault: '#DEE4DC',
    borderLight: '#EAEEE7',
    bgPlaceholder: '#F3F5EF',
    // 功能色
    success: '#12B76A',
    warning: '#F79009',
    error: '#F04438',
    info: '#2E90FA',
    // Header
    headerBg: '#FAFAF3',
    headerGradient: '#FAFAF3',
    // Modal
    modalContentBg: '#FAFAF3',
    modalHeaderBg: '#FAFAF3',
    modalTitleColor: '#1D2939',
    modalFooterBg: '#FAFAF3',
    // Menu
    menuSelectedText: '#2F382D',
    // Button
    buttonPrimaryText: '#252526',
    // 全局状态
    textDisabled: '#B4BECC',
    // Sidebar
    siderBg: '#F8FAF7',
    siderBgHover: '#EEF2EC',
    siderBgActive: '#F1F3E8',
    siderItemBg: 'transparent',
    siderText: '#4F5B63',
    siderTextHover: '#253238',
    siderTextActive: '#2F382D',
    siderIcon: '#78817A',
    siderIconHover: '#515C50',
    siderIconActive: '#5E5A32',
    siderGradient: '#F8FAF7',
  },
};

// ── PC 端布局常量（从颜色预设中分离） ──

export const WEB_LAYOUT = {
  default: {
    radiusSm: '6px',
    radiusMd: '10px',
    radiusLg: '16px',
    shadowSm: '0 1px 2px rgba(15, 23, 42, 0.05)',
    shadowMd: '0 4px 6px -1px rgba(15,23,42,0.08), 0 2px 4px -2px rgba(15,23,42,0.04)',
    shadowLg: '0 10px 15px -3px rgba(15,23,42,0.08), 0 4px 6px -4px rgba(15,23,42,0.04)',
  },
  'soft-blue': {
    radiusSm: '6px',
    radiusMd: '10px',
    radiusLg: '14px',
    shadowSm: '0 1px 2px rgba(47, 128, 237, 0.06)',
    shadowMd: '0 8px 20px rgba(47, 128, 237, 0.08)',
    shadowLg: '0 16px 36px rgba(47, 128, 237, 0.08)',
  },
};

// ── 移动端预设（h5-scan / member / mall） ──

export const UNI_PRESETS = {
  default: {
    primary: '#CBC797',
    primaryHover: '#D9D4A8',
    primaryLight: 'rgba(203, 199, 151, 0.15)',
    bgPage: '#252526',
    bgCard: '#252526',
    bgHover: 'rgba(203, 199, 151, 0.08)',
    bgFill: '#303030',
    textPrimary: '#FFFFFF',
    textSecondary: '#999999',
    textTertiary: '#666666',
    textPlaceholder: '#999999',
    textInverse: '#FFFFFF',
    borderDefault: '#606060',
    borderLight: '#606060',
    bgPlaceholder: '#3a3a3a',
    success: '#4CAF50',
    warning: '#FF9800',
    error: '#ff4d4f',
    info: '#2196F3',
    headerBg: '#2c2c2e',
    siderBg: '#252526',
  },
  'black-gold': {
    primary: '#CBC797',
    primaryHover: '#D9D4A8',
    primaryLight: 'rgba(203, 199, 151, 0.15)',
    bgPage: '#252526',
    bgCard: '#303031',
    bgHover: 'rgba(203, 199, 151, 0.08)',
    bgFill: '#3A3A3C',
    textPrimary: '#FFFFFF',
    textSecondary: '#999999',
    textTertiary: '#666666',
    textPlaceholder: '#999999',
    textInverse: '#FFFFFF',
    borderDefault: '#606060',
    borderLight: '#606060',
    bgPlaceholder: '#3a3a3a',
    success: '#4CAF50',
    warning: '#FF9800',
    error: '#ff4d4f',
    info: '#2196F3',
    headerBg: '#1e2128',
    siderBg: '#252526',
  },
  platinum: {
    // 白金主题 - 明亮优雅风格
    primary: '#7C8CB5', // 铂金蓝灰色
    primaryHover: '#6A7AA8', // 铂金悬停
    primaryLight: 'rgba(124, 140, 181, 0.12)', // 铂金半透明背景
    bgPage: '#F8F9FC', // 浅灰蓝页面背景
    bgCard: '#FFFFFF', // 纯白卡片背景
    bgHover: 'rgba(124, 140, 181, 0.06)', // 铂金微光悬停
    bgFill: '#F0F2F5',
    textPrimary: '#2C3E50', // 深蓝灰文字
    textSecondary: '#5D6D7E', // 灰色辅助文字
    textTertiary: '#85929E', // 浅灰次要文字
    textPlaceholder: '#AEB6BF',
    textInverse: '#2C3E50',
    borderDefault: '#D5D8DC',
    borderLight: '#EAECEE',
    bgPlaceholder: '#EAECEE',
    success: '#27AE60',
    warning: '#F39C12',
    error: '#E74C3C',
    info: '#3498DB',
    headerBg: '#FFFFFF', // 白色头部背景
    siderBg: '#F8F9FC', // 浅灰蓝侧边栏
  },
};

// ── 移动端布局常量 ──

export const UNI_LAYOUT = {
  default: {
    radiusSm: '6px',
    radiusMd: '10px',
    radiusLg: '16px',
    shadowSm: '0 1px 2px rgba(15, 23, 42, 0.05)',
    shadowMd: '0 4px 6px -1px rgba(15,23,42,0.08), 0 2px 4px -2px rgba(15,23,42,0.04)',
    shadowLg: '0 10px 15px -3px rgba(15,23,42,0.08), 0 4px 6px -4px rgba(15,23,42,0.04)',
  },
};

/**
 * 配色方案元数据（两端共享）
 */
export const SCHEME_META = {
  default: { label: '默认模板', deep: false },
  'soft-blue': { label: '浅蓝后台', deep: false },
  'black-gold': { label: '黑金主题', deep: true },
  platinum: { label: '白金主题', deep: false },
  champagne: { label: '香槟主题', deep: false },
};

export const WEB_SCHEME_NAMES = Object.keys(WEB_PRESETS);
export const UNI_SCHEME_NAMES = Object.keys(UNI_PRESETS);

/** @deprecated 使用 WEB_PRESETS 替代 */
export const THEME_PRESETS = WEB_PRESETS;
/** @deprecated 使用 WEB_SCHEME_NAMES 或 UNI_SCHEME_NAMES 替代 */
export const SCHEME_NAMES = WEB_SCHEME_NAMES;
